<template>
	<div>
		<!--<Menubar
			:model="menuItems"
			style="height:10px;width:10px;background-color:white;"
		/>-->
		<el-dropdown trigger="click">
			<span class="el-dropdown-link">
				<i class="el-icon-arrow-down el-icon--right"></i>
			</span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item icon="el-icon-back" @click.native="popDialog(0)"
					>AddColumnLeft</el-dropdown-item
				>
				<el-dropdown-item
					icon="el-icon-delete"
					@click.native="showDeleteDialog()"
					>DeleteCurrentCol</el-dropdown-item
				>
				<el-dropdown-item icon="el-icon-right" @click.native="popDialog(1)"
					>AddColumnRight</el-dropdown-item
				>
			</el-dropdown-menu>
		</el-dropdown>
		<Dialog
			:visible.sync="isDeleteDialog"
			header="Confirm"
			:modal="true"
		>
		<!-- :style="{ width: '450px' }" -->
			<div class="confirmation-content">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
				<span>Are you sure you want to delete ?</span>
			</div>
			<template #footer>
				<Button
					label="No"
					icon="pi pi-times"
					class="p-button-text"
					@click="isDeleteDialog = false"
				/>
				<Button
					label="Yes"
					icon="pi pi-check"
					class="p-button-text"
					@click="deleteColumn"
				/>
			</template>
		</Dialog>
	</div>
</template>
<script>
//import Menubar from "primevue/menubar/Menubar";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
export default {
	name: "InputSrMenubar",
	components: {
		Dialog,
		Button
	},
	props: {
		colIndex: Number
	},
	data() {
		return {
			lor: 0,
			isDeleteDialog: false,
			colLabel: "",
			newCol: { LorR: "", Index: "", ColLabel: "" }
		};
	},
	methods: {
		addColumn() {
			this.newCol.LorR = this.lor;
			this.newCol.Index = this.colIndex;
			this.newCol.ColLabel = this.colLabel;
			this.$emit("addCol", this.newCol);
		},
		deleteColumn() {
			this.isDeleteDialog = false;
			this.$emit("deleteCol", this.colIndex);
		},
		popDialog(lr) {
			this.$prompt("NewColumn Name:", "New Column", {
				confirmButtonText: "OK",
				cancelButtonText: "Cancel"
			})
				.then(({ value }) => {
					//console.log(value, lr);
					this.lor = lr;
					this.colLabel = value;
					this.addColumn();
					this.$message({
						type: "success",
						message: "Add successfully!"
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "Canceled"
					});
				});
		},
		showDeleteDialog() {
			this.isDeleteDialog = true;
		}
	}
};
</script>
<style scoped>
.el-dropdown {
	color: azure !important;
}
</style>
